import React from 'react'
import { pxToRem } from 'theme'
import { Box } from 'components/Layout'
import Card from 'components/Card'

export const QuestionnairePageLayout: React.FC = ({ children }) => (
  <Box display="flex" justifyContent="center">
    <Card p="2rem" width="100%" borderRadius="0" maxWidth={pxToRem(550)}>
      {children}
    </Card>
  </Box>
)
